import { __read } from "tslib";
/* eslint-disable import/prefer-default-export */
import { useEffect, useState } from 'react';
export var useExpandedState = function (initialValue) {
    if (initialValue === void 0) { initialValue = false; }
    var _a = __read(useState(initialValue), 2), expanded = _a[0], setExpanded = _a[1];
    var onClick = function () { return setExpanded(!expanded); };
    var collapse = function () { return setExpanded(false); };
    var expand = function () { return setExpanded(true); };
    useEffect(function () {
        setExpanded(initialValue);
    }, [initialValue]);
    return { expanded: expanded, onClick: onClick, collapse: collapse, expand: expand, toggle: onClick };
};
